import React, { useRef } from 'react';
import { Modal, Button, Input, Select, Form, Row, Col, Divider, message } from 'antd';
import authService from '../../../Redux/Services/authService';
import { getCurrentUser } from '../../../utils/auth';

const { Option } = Select;

const Address = ({ visible, onCancel, onSuccess }) => {
  const formRef = useRef();

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    const user = getCurrentUser();
    const userId = user?.userId || user?.userCode || localStorage.getItem("userCode");
    if (!userId) {
      message.error("Please log in to add a delivery address.");
      return;
    }

    const values = formRef.current?.getFieldsValue();
    const { name, number, email, addressone, addresstwo, landmark, addresstype, city, state, country, pincode } = values || {};

    if (!name || !number || !email || !addressone || !city || !state || !country || !pincode) {
      message.error("Please fill in all required fields");
      return;
    }

    const currDate = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const constructedTime = `${currDate.getFullYear()}-${pad(currDate.getMonth() + 1)}-${pad(currDate.getDate())} ${pad(currDate.getHours())}:${pad(currDate.getMinutes())}:${pad(currDate.getSeconds())}`;

    const payload = {
      address1: addressone,
      address2: addresstwo || "",
      addressType: (addresstype || "HOME").toUpperCase(),
      city: city,
      country: country,
      createdBy: userId,
      createdDate: constructedTime,
      email: email,
      landmark: landmark || "",
      mobileNumber: number,
      modifiedBy: userId,
      modifiedDate: constructedTime,
      name: name,
      pincode: pincode,
      sno: 0,
      state: state,
      status: 1,
      userId: userId
    };

    try {
      await authService.addAddress(payload);
      message.success("Address added successfully!");
      if (formRef.current) {
        formRef.current.resetFields();
      }
      if (onSuccess) {
        onSuccess();
      }
      onCancel();
    } catch (err) {
      console.error("Add address error:", err);
      message.error(err?.response?.data?.message || "Failed to save address. Please try again.");
    }
  };

  return (
    <Modal
      title={<span className='text-2xl'>Billing Address</span>}
      visible={visible}
      onCancel={onCancel}
      width={600}
      footer={[]}
    >
      <Divider />
      <Form
        ref={formRef}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label={<span className='text-base'>Name<span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your first name' }]}
            >
              <Input placeholder="name" className='h-10' />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="number"
              label={<span className='text-base'>Mobile No <span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your mobile no' }]}

            >
              <Input placeholder="Enter your Number" className='h-10' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label={<span className='text-base'>Email <span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your Email' }]}

            >
              <Input placeholder="Email" className='h-10' />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="addressone"
              label={<span className='text-base'>House No/Building name <span className='text-red-500'></span></span>}
              rules={[{ message: '' }]}

            >
              <Input placeholder="" className='h-10' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="addresstwo"
              label={<span className='text-base'>Road name/Area/Colony <span className='text-red-500'></span></span>}
              rules={[{ message: '' }]}

            >
              <Input placeholder="" className='h-10' />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="landmark"
              label={<span className='text-base'>Landmark<span className='text-red-500'></span></span>}
            >
              <Input placeholder="Apartment or suite" className='h-10' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="addresstype"
              label={<span className='text-base'>Home/Office<span className='text-red-500'>*</span></span>}
              rules={[{ message: '' }]}

            >
              <Select placeholder="Select a home or office" className='h-10'>
                <Option value="home">Home</Option>
                <Option value="office">Office</Option>
              </Select>
            </Form.Item>


          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="city"
              label={<span className='text-base'>City<span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your city' }]}

            >
              <Select placeholder="Select a city" className='h-10'>
                <Option value="Chennai">Chennai</Option>
              </Select>
            </Form.Item>

          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="state"
              label={<span className='text-base'>State<span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your state' }]}

            >
              <Select placeholder="Select a state" className='h-10'>
                <Option value="Tamil Nadu">Tamil Nadu</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>

            <Form.Item
              name="country"
              label={<span className='text-base'>Country<span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your country' }]}

            >
              <Select placeholder="Select a country" className='h-10'>
                <Option value="India">India</Option>
                {/* Add more countries as options */}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>

            <Form.Item
              name="pincode"
              label={<span className='text-base'>Pin Code<span className='text-red-500'>*</span></span>}
              rules={[{ message: 'Please enter your pin code' }]}

            >
              <Input placeholder="" className='h-10' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className='flex items-center justify-end gap-2'>
        <button className='w-28 rounded-lg p-2 bg-[#A17A17] text-white border-none' onClick={onCancel}>
          Cancel
        </button>
        <button className='w-28 rounded-lg p-2 bg-[#A17A17] text-white border-none' onClick={handleSubmit}>
          Save
        </button>
      </div>

    </Modal>
  );
};

export default Address;